import { jsx as _jsx } from "react/jsx-runtime";
import { EllipsisHorizontalIcon, UserMinusIcon, } from "@heroicons/react/24/outline";
import { __ } from "@wordpress/i18n";
import { WPQTDropdown, WPQTDropdownIcon, WPQTDropdownItem, } from "../WPQTDropdown";
function UserTaskDropdown({ taskId, onUnAssignTask }) {
    return (_jsx(WPQTDropdown, { menuBtn: ({ active }) => (_jsx(WPQTDropdownIcon, { isActive: active, IconComponent: EllipsisHorizontalIcon })), children: _jsx(WPQTDropdownItem, { text: __("Unassign from task", "quicktasker"), icon: _jsx(UserMinusIcon, { className: "wpqt-icon-red wpqt-size-4" }), onClick: (e) => {
                e.stopPropagation();
                onUnAssignTask(taskId);
            }, className: "!wpqt-mb-0" }) }));
}
export { UserTaskDropdown };
